import { api_post } from '@lf/api-client/lfApi';

export async function getProgressSummary(username, days = 30, setError = null) {
    return api_post('/progress/summary', { child_username: username, days }, setError);
}
